import React from "react";
// used for making the prop types of this component
import PropTypes from "prop-types";

import axios from 'axios';
// core components
import Button from "components/CustomButtons/Button.jsx";

import defaultLogo from "assets/img/logo_placeholder.jpg";
import { getApiHeaders } from "../../assets/helpers/apiHelper";
import { API_ROOT } from 'api-config';

class ImageUpload extends React.Component {
  constructor(props) {
    super(props);
    var userId = ''
    if (this.props.userId) {
      userId = this.props.userId
    }
    this.state = {
      file: null,
      imagePreviewUrl: defaultLogo,
      userId: userId
    };
    this.handleImageChange = this.handleImageChange.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
  }

  componentDidMount(){
    this._isMounted = true;
    this.getLogo()
  }

  getLogo() {
    axios.get(`${API_ROOT}/logo/?userId=` + this.state.userId, { headers: getApiHeaders() })
      .then(res => this.setLogo({ responseMessage: res.data }));
  }

  setLogo(res){
    if (res.responseMessage.logoFile && res.responseMessage.logoFile !== 'no logo') {
      this.setState({
        file: res.responseMessage.logoFile,
        imagePreviewUrl: res.responseMessage.logoFile
      });
    }
  }
  handleImageChange(e) {
    e.preventDefault();
    let file = e.target.files[0];
    const formData = new FormData();
    formData.append('file', file);
    formData.append('userId', this.state.userId);
    axios.post(`${API_ROOT}/logo/`, formData, { headers: getApiHeaders() })
      .then(res => this.handleLogoUploadResponse(res));
  }
  handleLogoUploadResponse(res) {
    if (res.data.status === 'success') {
      this.setState({
        file: res.data.logoFile,
        imagePreviewUrl: res.data.logoFile
      });
    } else {
      alert(res.data.error)
    }
  }
  handleClick() {
    this.refs.fileInput.click();
  }
  handleRemove() {
    const logoData = {
      userId: this.state.userId
    }
    axios.delete(`${API_ROOT}/logo/`, {data: logoData, headers: getApiHeaders()})
      .then(res => this.handleDeleteLogo(res));
    this.setState({
      file: null,
      imagePreviewUrl: defaultLogo
    });
    this.refs.fileInput.value = null;
  }

  handleDeleteLogo(res) {
    if (res.data.status === 'success') {
      this.setState({
        file: null,
        imagePreviewUrl: defaultLogo
      });
    } else {
      alert(res.data.error)
    }
  }
  render() {
    var {
      addButtonProps,
      changeButtonProps,
      removeButtonProps
    } = this.props;
    return (
      <div className="fileinput text-center">
        <input type="file" onChange={this.handleImageChange} ref="fileInput" />
        <div className={"thumbnail"}>
          <img src={this.state.imagePreviewUrl} alt="..." />
        </div>
        <div>
          {this.state.file === null ? (
            <Button {...addButtonProps} onClick={() => this.handleClick()}>
              {"Select logo"}
            </Button>
          ) : (
            <span>
              <Button {...changeButtonProps} onClick={() => this.handleClick()}>
                Change
              </Button>
              <Button
                {...removeButtonProps}
                onClick={() => this.handleRemove()}
              >
                <i className="fas fa-times" /> Remove
              </Button>
            </span>
          )}
        </div>
      </div>
    );
  }
}

ImageUpload.propTypes = {
  addButtonProps: PropTypes.object,
  changeButtonProps: PropTypes.object,
  removeButtonProps: PropTypes.object
};

export default ImageUpload;
